import { PoolOptions } from "@quint/components";
import { cn } from "@quint/ui";
import { AccordionContent, AccordionItem, AccordionTrigger } from "@quint/ui/accordion";
import { ChevronDown } from "lucide-react";
import { isValidElement, useRef } from "react";
import { Pool } from "./pool";
import type { StakingCardDatum } from "./types";

export const StakingCardMobile = (props: StakingCardDatum) => {
  const { deprecated, Icon, name, rewards, address, harvestButton } = props;
  const ref = useRef<HTMLDivElement>(null);

  return (
    <AccordionItem
      ref={ref}
      value={name}
      className={cn(
        "p-6",
        "rounded-2xl",
        "min-h-[122px]",
        "cursor-pointer data-[state=open]:cursor-auto",
        "border-[1px] border-solid border-[#E6E8EA] dark:border-[#354856]",
        "flex flex-col items-center justify-between",
        "data-[state=open]:border-[#22C994] data-[state=open]:bg-[#C9EDE0] data-[state=open]:dark:bg-[#16464B]"
      )}
    >
      <AccordionTrigger>
        <div className="flex grow flex-col gap-6">
          <div className="flex flex-row justify-between">
            <div className="flex gap-6">
              {/* icon */}
              <Icon />
              <div>
                {/* name */}
                <p className={cn(deprecated && "line-through", "text-left")}>{name}</p>
                {/* rewards */}
                <div className="mt-2 flex flex-col text-left sm:mt-0 sm:flex-row sm:gap-4">
                  <p className="text-slate-700 dark:text-slate-300">REWARDS</p>
                  <p>{isValidElement(rewards) ? rewards : null}</p>
                </div>
              </div>
            </div>
            <PoolOptions address={address} />
          </div>
          {/* harvest + chevron */}
          <div className="flex items-center gap-10">
            {isValidElement(harvestButton) ? harvestButton : null}
            <ChevronDown className="w-[48px] transition-transform duration-200" />
          </div>
        </div>
      </AccordionTrigger>
      <AccordionContent>
        <Pool pool={props} />
      </AccordionContent>
    </AccordionItem>
  );
};
